export default "__VITE_ASSET__QtiC9qNH__"